// extracted by mini-css-extract-plugin
export default {"cart-items":"Cart_cart-items__40VAm","total":"Cart_total__lkIZU","actions":"Cart_actions__p0QZE","button--alt":"Cart_button--alt__LcdhT","button":"Cart_button__1TnCX"};